import { useQuery } from '@tanstack/react-query';
import { getAutomationUsage } from '@/services/dmAutomation.service';
import { queryKeys } from '@/hooks/queries/keys';

/** 이용권 통합 내역(요약 + 충전/사용 타임라인). 이용권 화면용. */
export const useAutomationUsage = (options?: { enabled?: boolean }) => {
    return useQuery({
        queryKey: queryKeys.dmAutomation.usage(),
        queryFn: getAutomationUsage,
        enabled: options?.enabled ?? true,
    });
};
